import $ from 'jQuery';

export default function () {
	$(function() {
		slider_init();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class Slider {
		/**
		 * Slider Constructor
		 * @param {HTML Element} element Element to transform into a slick slider.
		 * @param {object} options Optional settings to overwrite the defaults.
		 */
		constructor(element, options) {
			// Grabs reference to the passed in element.
			this.element = element;

			// We can pass in alternate options to overwrite the defaults.
			this.settings = { ...slickDefaults, ...options };

			// Sets a slider variable from the returned slick slider instance built.
			this.slider = this.build();

			// Calls a utility ready function when everything is done.
			this.ready();
		}

		/**
		 * Builds out a slick slider from the element and the settings.
		 * @returns jQuery Element
		 */
		build() {
			return $(this.element).slick(this.settings);
		}

		/**
		 * Utility function to add a ready class to the element.
		 */
		ready() {
			this.element.classList.add('ready');
		}
	}

	function slider_init() {
		const $carousel = $('.block--slider');

		if ($carousel.length) {
			$('.slider--slides--images', $carousel).each(function() {
				const $thisSlider = $(this);
				let el = $thisSlider[0];

				const slickSettings = {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					variableWidth: true,
					variableHeight: true,
					arrows: false,
					draggable: false,
					//infinite: false,
					asNavFor: '.slider--slides--text',
				};

				if (!el.Slider) {
					el.Slider = new Slider(el, slickSettings);
				}
			});

			$('.slider--slides--text', $carousel).each(function() {
				const $thisSlider = $(this);
				let el = $thisSlider[0];

				const slickSettings = {
					slidesToShow: 1,
					fade: true,
					//infinite: false,
					cssEase: 'linear',
					asNavFor: '.slider--slides--images',
				};

				if (!el.Slider) {
					el.Slider = new Slider(el, slickSettings);
				}
			});
		}
	}
}
